import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { createOrUpdateUserSSCDetailsGraphQlMutation } from '../../../graphQL/NiatApplicationPortal/mutations/createOrUpdateUserSSCDetails';
import {
  MutationGraphQlResponseType,
  UpdateUserSSCDetailsRequestObjectType
} from '../../../services/IbUserAccountsServices/GraphQlService/types';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface UseUpdateUserSSCDetailsGraphQlInterface {
  updateUserSSCDetailsGraphQLApi: UseMutateAsyncFunction<
    MutationGraphQlResponseType,
    Error,
    UpdateUserSSCDetailsRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateUserSSCDetailsGraphQl =
  (): UseUpdateUserSSCDetailsGraphQlInterface => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();

    const updateUserSSCDetails = (data) => {
      const mutationDetail = createOrUpdateUserSSCDetailsGraphQlMutation();
      return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
        mutationDetail.mutation,
        {
          user_ssc_details_input: data
        }
      );
    };

    const { mutateAsync, error, status } = useMutation(updateUserSSCDetails, {
      mutationKey: ['updateUserSSCDetailsGraphQLApi']
    });

    return {
      updateUserSSCDetailsGraphQLApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useUpdateUserSSCDetailsGraphQl };
